import $ from 'jquery';
import 'web-animations-js';
import Muuri from 'muuri'; //for dev only, use as dependency on live/staging
import { onResize, getWidth } from "../utils/window";
import lazy from '../directives/scroll/lazy-load';

//get elements
let grid;
let gridElement = document.querySelector('.content > .cards > .grid');

let isProjects = false;

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function initialise() {
  let expertiseField = document.querySelector('.content > .form [name="expertise"]');
  let positionField = document.querySelector('.content > .form [name="position"]');
  let searchField = document.querySelector('.content > .form [name="q"]');
  let sortField = document.querySelector('.content > .form [name="sort_by"]');
  let locationsField = document.querySelector('.content > .form [name="locations"]');
  let sectorsField = document.querySelector('.content > .form [name="sectors"]');

  let searchFieldValue, expertiseFieldValue, positionFieldValue, sortFieldValue,
    locationsFieldValue, sectorsFieldValue;

  let projectOffset = 1;
  let projectLastButton = null;
  if ($('#content.projectsIndex').length || $('#content.sgsLab').length) {
    isProjects = true;
  }

  //create Muuri grid
  grid = new Muuri(gridElement, {
    layout: {
      fillGaps: true,
      alignRight: false,
      rounding: false
    },
    layoutOnResize: 300,
    dragSort: false,
  });

  //reset values
  searchField.value = '';

  let arr = [];

  if (expertiseField && expertiseField.length) {
    arr.push(expertiseField);
  }

  if (positionField && positionField.length) {
    arr.push(positionField);
  }

  if (sortField && sortField.length) {
    arr.push(sortField);
  }

  if (locationsField && locationsField.length) {
    arr.push(locationsField);
  }

  if (sectorsField && sectorsField.length) {
    arr.push(sectorsField);
  }

  arr.forEach(function (field) {
    let name = field.getAttribute('name');

    if (name === 'sort_by') {
      field.value = field.querySelectorAll('option')[1].value;
    } else {
      field.value = field.querySelectorAll('option')[0].value;
    }
  });

  // Set inital search query, active filter, active sort value and active layout.
  searchFieldValue = searchField.value.toLowerCase();

  if (expertiseField && expertiseField.length) {
    expertiseFieldValue = expertiseField.value;
  }

  if (positionField && positionField.length) {
    positionFieldValue = positionField.value;
  }

  if (sortField && sortField.length) {
    sortFieldValue = sortField.value;
  }

  if (locationsField && locationsField.length) {
    locationsFieldValue = locationsField.value;
  }

  if (sectorsField && sectorsField.length) {
    sectorsFieldValue = sectorsField.value;
  }

  // Search field binding.
  searchField.addEventListener('keyup', function () {
    let newSearch = searchField.value.toLowerCase();
    if (searchFieldValue !== newSearch) {
      searchFieldValue = newSearch;
      filter();
    }
  });

  const updateIndices = function () {

    grid.getItems().forEach(function (item, i) {
      item.getElement().setAttribute('data-id', i);
    });

  };

  // 	if ($('#content.projectsIndex').length) {
  // 		isProjects = true;
  // 	}
  const filter = function () {
    if (expertiseField && expertiseField.length) {
      expertiseFieldValue = expertiseField.value.toLowerCase();
    }

    if (positionField && positionField.length) {
      positionFieldValue = positionField.value.toLowerCase();
    }

    if (locationsField && locationsField.length) {
      locationsFieldValue = locationsField.value.toLowerCase();
    }

    if (sectorsField && sectorsField.length) {
      sectorsFieldValue = sectorsField.value.toLowerCase();
    }

    grid.filter(function (item) {
      let element = item.getElement();

      let isSearchMatch = !searchFieldValue ? true :
        (element.getAttribute('data-firstname') || '').toLowerCase().indexOf(searchFieldValue) > -1
        ||
        (element.getAttribute('data-lastname') || '').toLowerCase().indexOf(searchFieldValue) > -1;

      let isExpertiseMatch = true;
      if (expertiseField && expertiseField.length) {
        isExpertiseMatch = !expertiseFieldValue ? true : (element.getAttribute('data-services') || '').toLowerCase()
        .indexOf(expertiseFieldValue) > -1;
      }

      let isPositionMatch = true;
      if (positionField && positionField.length) {
        isPositionMatch = !positionFieldValue ? true : (element.getAttribute('data-positions') || '').toLowerCase()
        .indexOf(positionFieldValue) > -1;
      }

      let isLocationsMatch = true;
      if (locationsField && locationsField.length) {
        isLocationsMatch = !locationsFieldValue ? true : (element.getAttribute('data-locations') || '').toLowerCase()
        .indexOf(locationsFieldValue) > -1;
      }

      let isSectorssMatch = true;
      if (sectorsField && sectorsField.length) {
        isSectorssMatch = !sectorsFieldValue ? true : (element.getAttribute('data-sectors') || '').toLowerCase()
        .indexOf(sectorsFieldValue) > -1;
      }

      return isSearchMatch && isExpertiseMatch && isPositionMatch && isLocationsMatch && isSectorssMatch;
    });

    setHeightOfCards();
    grid.refreshItems();
    grid.layout();

    setTimeout(() => {
      lazy();
    }, 500);
  };

  const compareName = function (a, b) {
    let aVal = a.getElement().getAttribute('data-firstname') || '';
    let bVal = b.getElement().getAttribute('data-firstname') || '';
    return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
  };

  const compareLastName = function (a, b) {
    let aVal = a.getElement().getAttribute('data-lastname') || '';
    let bVal = b.getElement().getAttribute('data-lastname') || '';
    return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
  };

  const compareDate = function (a, b) {
    let aVal = new Date(a.getElement().getAttribute('data-postdate')) || '';
    let bVal = new Date(b.getElement().getAttribute('data-postdate')) || '';
    return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
  };

  const randomize = function (a, b) {
    let aVal = (Math.random() * 10) - 1;
    let bVal = (Math.random() * 10) - 1;

    return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
  };

  const sort = function () {

    // Do nothing if sort value did not change.
    let currentSort = sortField.value;
    if (sortFieldValue === currentSort) {
      return;
    }

    let split = currentSort.split(' ');
    let desc = true;

    if (split.length > 1) {
      if (split[1] === 'asc') {
        desc = false;
      }

      currentSort = split[0];
    }

    // Sort the items.
    switch (currentSort) {
      case 'firstname':
        grid.sort(compareName, {
          descending: desc,
        });
        break;
      case 'lastname':
        grid.sort(compareLastName, {
          descending: desc,
        });
        break;
      case 'postdate':
        grid.sort(compareDate, {
          descending: desc,
        });
        break;
      default:
        grid.sort(randomize, {
          descending: desc,
        });

        grid.refreshSortData();
        break;
    }

    // Update indices and active sort value.
    updateIndices();
    sortFieldValue = currentSort;
    setHeightOfCards();
    grid.refreshItems();
    grid.layout();
  };

  const noFilterItems = function () {
    let hasFiltered = searchFieldValue || expertiseFieldValue || locationsFieldValue || sectorsFieldValue;
    let offsetAmount = projectOffset * 6;

    // if none are hidden and no filters
    // show only the offset amount of items.
    if (!hasFiltered) {
      let cells = $(`#content .cards .grid .cell`);
      let numberOfItemsToShow = cells.slice(0, offsetAmount).toArray();
      let numberOfItemsToHide = cells.slice(offsetAmount, cells.length).toArray();
      grid.show(numberOfItemsToShow);
      grid.hide(numberOfItemsToHide);

      if (projectLastButton && projectLastButton.length) {
        projectLastButton.find('#show').fadeIn(400);
      }

      setHeightOfCards();
      grid.refreshItems();
      grid.layout();

      lazy();

      // console.log(cells.length);
      if (cells.length === $(`#content .cards .grid .cell.muuri-item-shown`).length && projectLastButton && projectLastButton.length) {
        projectLastButton.remove();
      }
    }
  };

  // Filter, sort and layout bindings.
  if (expertiseField && expertiseField.length) {
    expertiseField.addEventListener('change', filter);
  }

  if (positionField && positionField.length) {
    positionField.addEventListener('change', filter);
  }

  if (locationsField && locationsField.length) {
    locationsField.addEventListener('change', filter);
  }

  if (sectorsField && sectorsField.length) {
    sectorsField.addEventListener('change', filter);
  }

  if (sortField && sortField.length) {
    sortField.addEventListener('change', sort);
    grid.sort(randomize);
    setTimeout(() => {
      lazy();
    }, 500);
  }

  window.addEventListener('sw-added-to-list', e => {

    const ITEMS = e.detail.items;

    // ITEMS.each(function(){
    //     const _THIS = this;
    //     grid.add(_THIS);
    // 	grid.hide(_THIS, {
    // 		instant: true
    // 	});
    // });
    grid.add(ITEMS);
    grid.hide(ITEMS, {
      instant: true
    });

    projectLastButton = $('#content .content .cards .more.projects-more');

    if (isProjects && projectLastButton.length) {
      projectLastButton.find('#show').click(function () {
        projectOffset += 1;
        noFilterItems();
      });
    }

    setHeightOfCards();
    grid.refreshItems();
    grid.layout();
  });

  grid.on('hideStart', function (items) {
    if ($('#content .cards .grid .cell').length === items.length) {
      $('#content .cards .cards-error').fadeIn(400);

      // if (projectLastButton.length) {
      // 	projectLastButton.find('#show').fadeIn(400);
      // }
    }
  });

  grid.on('showStart', function (items) {
    if (items.length > 0) {
      $('#content .cards .cards-error').fadeOut(400);
      if (projectLastButton && projectLastButton.length) {
        projectLastButton.find('#show').fadeOut(400);
      }
    }
  });

  if (isProjects) {
    grid.on('filter', function (shownItems, hiddenItems) {
      if (!hiddenItems.length) {
        noFilterItems();
      } else {
        if (projectLastButton && projectLastButton.length) {
          projectLastButton.find('#show').fadeOut(400);
        }
      }
    });
  }
}

function addCssHeight(element, height) {
  element.css('height', height + 'px');
}

function mainHeightIsSmaller(mainHeight, otherHeight) {
  return mainHeight < otherHeight;
}

function setHeightOfCards(isInit = false) {
  if ($('#content.projectsIndex').length || $('#content.sgsLab').length) {
    // $('.cards > .grid > .cell').css('height', 1000+'px');
    let cells = $('.cards > .grid > .cell.shown');

    if (isInit) {
      cells = $('.cards > .grid > .cell');
    } else {
      cells = $('.cards > .grid > .cell.muuri-item-shown');
    }

    //reset height
    let cellHeight = 0;
    cells.css('height', '');

    let min = 1;

    const updateCell = function (_this, row, index) {
      min = min + row;
      cellHeight = _this.outerHeight();

      let nextEl = $(cells[index + 1]);
      let nextNextEl = $(cells[index + 2])

      if (nextEl.length) {
        // if the next height is bigger than change height variable.
        if (mainHeightIsSmaller(cellHeight, nextEl.outerHeight())) {
          cellHeight = nextEl.outerHeight();
        }

        // now check if the nexts next element height is bigger
        if (nextNextEl.length && row === 3) {
          if (mainHeightIsSmaller(cellHeight, nextNextEl.outerHeight())) {
            cellHeight = nextNextEl.outerHeight();
          }
        }
      }

      addCssHeight(_this, cellHeight);
      if (nextEl.length) {
        addCssHeight(nextEl, cellHeight);

        if (nextNextEl.length && row === 3) {
          addCssHeight(nextNextEl, cellHeight);
        }
      }

      cellHeight = 0;
    };

    cells.each(function (index) {
      let _this = $(this);
      let index1 = index + 1;

      if (getWidth() >= 1296) {
        if (index1 === 1 || index1 % min === 0) {
          updateCell(_this, 3, index);
        }
      } else {
        if (getWidth() >= 672) {
          if (index1 === 1 || index1 % min === 0) {
            updateCell(_this, 2, index);
          }
        } else {
          cells.css('height', '');
        }
      }
    });
  }
}

export default function muu() {
  const $html = $('html');
  const $scroller = $('html, body');

  $(function () {
    const MUU = $('#content.people').length || $('#content.projectsIndex').length || $('#content.sgsLab').length;

    if (MUU) {

      setHeightOfCards(true);
      setTimeout(function () {
        // setHeightOfCards();
        initialise();

        setTimeout(() => {
          onResize(function () {
            setHeightOfCards();
            grid.refreshItems();
            grid.layout();
          });
        }, 300);

      }, 100);
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/pages/muuri.js